import {
  emailUI,
  phoneUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { ContactInfoDescription } from '../../../components/FormDescriptions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--contact-info-title'];
const INPUT_LABELS = {
  home: content['vet-info--contact-info-home-phone-label'],
  mobile: content['vet-info--contact-info-mobile-phone-label'],
};
const ERR_MSGS = {
  email: content['validation-error--email-pattern'],
  phone: content['validation-error--phone-pattern'],
};

const { email, homePhone, mobilePhone } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, ContactInfoDescription),
    email: emailUI({
      errorMessages: { pattern: ERR_MSGS.email },
    }),
    homePhone: phoneUI({
      title: INPUT_LABELS.home,
      errorMessages: { pattern: ERR_MSGS.phone },
    }),
    mobilePhone: phoneUI({
      title: INPUT_LABELS.mobile,
      errorMessages: { pattern: ERR_MSGS.phone },
    }),
  },
  schema: {
    type: 'object',
    properties: { email, homePhone, mobilePhone },
  },
};
